import { i18nMark } from '@lingui/react'
import {
  Usage,
  Statement,
  Account,
  Support,
  Wholesale,
  Renewal,
  Devices,
  Battery,
} from './Sidebar/icons'
import { routes } from 'config/profile'

const urls = [
  {
    label: i18nMark('Wholesale'),
    to: '/wholesale',
    Icon: Wholesale,
    isPermitted: routes.wholesale,
    showLink: ({ isConsolidatedMember }) => !isConsolidatedMember,
  },
  {
    label: i18nMark('Account'),
    to: '/account',
    Icon: Account,
    isActive: (match, location) => {
      if (
        location.pathname.startsWith('/account') &&
        location.pathname !== '/account/meter-summary'
      ) {
        return true
      }
      return false
    },
    isPermitted: !routes.accountNotAvailable,
  },
  {
    label: i18nMark('Renewal'),
    to: '/renewal',
    Icon: Renewal,
    isPermitted: false,
    showLink: ({ isCSMeter, isConsolidatedMember }) => !isCSMeter && !isConsolidatedMember,
  },
  {
    label: i18nMark('Devices'),
    to: '/devices',
    Icon: Devices,
    isPermitted: routes.devices,
    showLink: ({ isCSMeter, isConsolidatedMember }) => !isCSMeter && !isConsolidatedMember,
  },
  {
    label: i18nMark('Battery'),
    to: '/battery',
    Icon: Battery,
    isPermitted: routes.battery,
    showLink: ({ isBatteryCustomer }) => !!routes.battery && !!isBatteryCustomer,
  },
  {
    label: i18nMark('Electricity Usage'),
    to: '/usage',
    Icon: Usage,
    showLink: ({ isCSMeter, isConsolidatedMember, isBatteryCustomer }) => !isCSMeter && !isConsolidatedMember && !isBatteryCustomer,
    isPermitted: !routes.usageNotAvailable,
  },
  {
    label: i18nMark('Statement'),
    to: '/statement',
    Icon: Statement,
    isPermitted: !routes.statementNotAvailable,
  },
  {
    label: i18nMark('Support'),
    to: '/help',
    Icon: Support,
    isPermitted: !routes.helpNotAvailable,
  },
]

export default urls
